import React from 'react';
import PropTypes from 'prop-types';
import { Navigation } from '@shopify/polaris';
import { AppsIcon, CalendarIcon, OrderIcon, TeamIcon } from '@shopify/polaris-icons';
import * as styles from '../layout/Sidebar.module.scss';

const Sidebar = ({ pathname, onNavigate, counts }) => (
  <div className={styles.container}>
    <Navigation location="/promotions">
      <Navigation.Section
        title="Partner promotions"
        items={[
          {
            label: counts.live != null ? `Featured banners (${counts.live} live)` : 'Featured banners',
            icon: CalendarIcon,
            selected: pathname.startsWith('/promotions/banners'),
            onClick: () => onNavigate('/promotions/banners'),
          },
          {
            label: counts.cards != null ? `Partner cards (${counts.cards})` : 'Partner cards',
            icon: AppsIcon,
            selected: pathname.startsWith('/promotions/cards'),
            onClick: () => onNavigate('/promotions/cards'),
          },
          {
            label: 'Display order',
            icon: OrderIcon,
            selected: pathname.startsWith('/promotions/order'),
            onClick: () => onNavigate('/promotions/order'),
          },
        ]}
      />
      <Navigation.Section
        title="Elsewhere"
        items={[
          { label: 'Referrers', icon: TeamIcon, url: '/referrers' },
        ]}
      />
    </Navigation>
  </div>
);

Sidebar.propTypes = {
  pathname: PropTypes.string.isRequired,
  onNavigate: PropTypes.func.isRequired,
  counts: PropTypes.object.isRequired,
};

export default Sidebar;
